import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import redemptionsApiClient from 'Services/Apis/Spot/redemptionsClient';

export const loadViewRedemption = createAsyncThunk(
  'ViewRedemptionSlice/loadViewRedemption',
  async ({ id }, { getState }) => {
    const { user } = getState().oidc;

    const config = {
      Authorization: `Bearer ${user.access_token}`,
      campaignId: user.profile['custom:campaign_id'],
      catalogId: user.profile['custom:catalog_id'],
      participantId: user.profile['custom:participant_id'],
      username: user.profile.username || user.profile['custom:login'],
    };

    const response = await redemptionsApiClient(`/Redemption/${id}`, {
      headers: config,
    });
    const { data } = response;
    return data;
  }
);

const initialState = {
  data: {},
  isLoading: false,
  error: false,
};

const ViewRedemptionSlice = createSlice({
  name: 'ViewRedemptionSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(loadViewRedemption.pending, (state) => {
      state.isLoading = true;
      state.error = false;
    });
    builder.addCase(loadViewRedemption.fulfilled, (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = false;
    });
    builder.addCase(loadViewRedemption.rejected, (state) => {
      state.isLoading = false;
      state.error = true;
    });
  },
});

export default ViewRedemptionSlice.reducer;
